import { useCallback, useState } from 'react'

export const usePageNavigation = (
	totalPages: number,
): { currentPage: number; goToNextPage: () => void; goBack: () => void } => {
	const [currentPage, setCurrentPage] = useState(0)

	const goToNextPage = useCallback(() => {
		setCurrentPage((prev) => prev + 1)
	}, [currentPage, totalPages])

	const goBack = useCallback(() => {
		if (currentPage === 0) return
		setCurrentPage((prev) => prev - 1)
	}, [currentPage])

	return {
		currentPage,
		goToNextPage,
		goBack,
	}
}
